// pro.rejouis.fr — primitives UI (charte Rejouis 2026, reprises de re.rejouis).
import heartUrl from '../assets/rejouis-heart.png';
import { naviguer } from '../lib/nav.js';

function Ic({ size = 20, sw = 2, style, children }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" style={style} aria-hidden="true">
      {children}
    </svg>
  );
}

export const Icons = {
  plus: (p) => <Ic {...p}><path d="M12 5v14M5 12h14" /></Ic>,
  back: (p) => <Ic {...p}><path d="M15 18l-6-6 6-6" /></Ic>,
  chev: (p) => <Ic {...p}><path d="M9 18l6-6-6-6" /></Ic>,
  pack: (p) => <Ic {...p}><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><path d="M3.3 7l8.7 5 8.7-5" /><path d="M12 22V12" /></Ic>,
  truck: (p) => <Ic {...p}><path d="M14 18V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h2" /><path d="M14 9h4l3 3v5a1 1 0 0 1-1 1h-1" /><circle cx="7.5" cy="18" r="2" /><circle cx="16.5" cy="18" r="2" /><path d="M9.5 18H14" /></Ic>,
  wallet: (p) => <Ic {...p}><path d="M19 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H5" /><circle cx="16" cy="14" r="1.4" fill="currentColor" stroke="none" /></Ic>,
  camera: (p) => <Ic {...p}><path d="M14.5 4h-5L7.9 6H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.9L14.5 4z" /><circle cx="12" cy="13" r="3.5" /></Ic>,
  download: (p) => <Ic {...p}><path d="M12 3v12" /><path d="m7 11 5 5 5-5" /><path d="M5 21h14" /></Ic>,
  external: (p) => <Ic {...p}><path d="M15 3h6v6" /><path d="M10 14 21 3" /><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" /></Ic>,
  logout: (p) => <Ic {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="m16 17 5-5-5-5" /><path d="M21 12H9" /></Ic>,
  spinner: (p) => <Ic {...p}><circle cx="12" cy="12" r="9" strokeOpacity="0.25" /><path d="M21 12a9 9 0 0 0-9-9" /></Ic>,
};

export function Spinner({ size = 16, label }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: 'var(--stone)', fontSize: 13 }}>
      <Icons.spinner size={size} sw={2.4} style={{ animation: 'proto-spin .9s linear infinite' }} />
      {label}
    </span>
  );
}

export function Logo({ size = 18 }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.42 }}>
      <img src={heartUrl} alt="" width={size * 1.55} height={size * 1.55} style={{ display: 'block' }} aria-hidden="true" />
      <span style={{ fontFamily: 'var(--font-logo)', fontSize: size, textTransform: 'lowercase', lineHeight: 1, display: 'inline-flex', alignItems: 'baseline' }}>
        <span style={{ color: 'var(--noir)' }}>rejouis</span>
        <span style={{ color: 'var(--rouge)', marginLeft: size * 0.3 }}>pro</span>
      </span>
    </span>
  );
}

// Barre de progression d'une étape (reçus → reconditionnés → vendus).
export function Jauge({ valeur, max, couleur = 'var(--bleu)' }) {
  const pct = max > 0 ? Math.min(100, Math.round((valeur / max) * 100)) : 0;
  return (
    <div style={{ height: 8, borderRadius: 999, background: 'var(--stone-pale)', overflow: 'hidden' }}>
      <div style={{ width: `${pct}%`, height: '100%', borderRadius: 999, background: couleur, transition: 'width .5s var(--ease)' }} />
    </div>
  );
}

// Lien de retour vers l'accueil de l'espace.
export function Retour({ label = 'Accueil' }) {
  return (
    <button className="btn btn-tertiary" style={{ padding: '14px 0', gap: 4 }} onClick={() => naviguer('/')}>
      <Icons.back size={16} /> {label}
    </button>
  );
}
